module.exports = __webpack_public_path__ + "img/mini-027.44fe1fd6.jpg";